import { RidangoReduxAction } from '@ridango/core';

import { RecoverPasswordActions } from './recover-password.actions';

export interface RecoverPasswordState {
    step: number;
    loading: boolean;
    done: boolean;
    error: any;
    authAccessToken: string;
}

export const RECOVER_PASSWORD_INITIAL_STATE: RecoverPasswordState = {
    step: 1,
    loading: false,
    done: false,
    error: null,
    authAccessToken: null
};

export function recoverPassordReducer(
    state: RecoverPasswordState = RECOVER_PASSWORD_INITIAL_STATE,
    action: RidangoReduxAction
): RecoverPasswordState {
    switch (action.type) {
        case RecoverPasswordActions.RECOVER_PASSWORD_REQUEST:
            return {
                ...state,
                loading: true,
                step: 1
            };
        case RecoverPasswordActions.RECOVER_PASSWORD_REQUEST_COMPLETE:
            return {
                ...state,
                loading: false,
                step: 2
            };
        case RecoverPasswordActions.RECOVER_PASSWORD_REQUEST_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case RecoverPasswordActions.RECOVER_PASSWORD_RESET_STEP:
            return {
                ...state,
                ...RECOVER_PASSWORD_INITIAL_STATE
            };
        case RecoverPasswordActions.RECOVER_PASSWORD_SET_STEP:
            return {
                ...state,
                step: action.payload
            };
        case RecoverPasswordActions.SET_NEW_PASSWORD:
            return {
                ...state,
                loading: true
            };
        case RecoverPasswordActions.SET_NEW_PASSWORD_SUCCESS:
            return {
                ...state,
                authAccessToken: action.payload.token,
                done: true
            };
        case RecoverPasswordActions.SET_NEW_PASSWORD_WITHOUT_LOGIN_SUCCESS:
            return {
                ...state,
                authAccessToken: null,
                done: true
            };
    }

    return state;
}
